export const supportedLanguages = {
  "en-US": "English",
  "pl-PL": "Polski",
  "pt-BR": "Português (BR)",
  "es-ES": "Español",
  "zh-CN": "中文 (简)",
  "cs-CZ": "Čeština",
  "de-DE": "Deutsch",
  "en-GB": "English (GB)",
  "fr-FR": "Français (FR)",
  "fr-CA": "Français (CA)",
  "it-IT": "Italiano",
  "hi-IN": "हिन्दी",
  "ja-JP": "日本語",
  "sk-SK": "Slovenský",
};
